import { createSlice } from '@reduxjs/toolkit'

const deleteAccountSlice = createSlice({
  name: 'deleteAccount',
  initialState: {
    option: '',
    reason: '',
  },
  reducers: {
    setDeleteAccountOption: (state, action) => {
      state.option = action.payload
    },
    setDeleteAccountReason: (state, action) => {
      state.reason = action.payload
    },
    resetDeleteAccountState: (state) => {
      state.option = ''
      state.reason = ''
    },
  },
})

export const { setDeleteAccountOption, setDeleteAccountReason, resetDeleteAccountState } =
  deleteAccountSlice.actions

export default deleteAccountSlice.reducer
